import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import CookieBanner from './components/CookieBanner';
import AIAssistant from './components/AIAssistant';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AppRoutes />
      <CookieBanner />
      <AIAssistant />
    </BrowserRouter>
  );
}

export default App;
